import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconMetricsGraph = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 16,
	viewBox: "0 0 18 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M1.6875 0.84375V13.2188C1.6875 13.7109 2.03906 14.0625 2.53125 14.0625H17.1562C17.6133 14.0625 18 14.4492 18 14.9062C18 15.3984 17.6133 15.75 17.1562 15.75H2.53125C1.125 15.75 0 14.625 0 13.2188V0.84375C0 0.386719 0.351562 0 0.84375 0C1.30078 0 1.6875 0.386719 1.6875 0.84375ZM11.25 4.21875C11.25 3.76172 11.6016 3.375 12.0938 3.375H15.9961C16.4883 3.375 16.8398 3.76172 16.8398 4.21875V8.15625C16.8398 8.64844 16.4883 9 15.9961 9C15.5391 9 15.1523 8.64844 15.1523 8.15625V6.25781L11.25 10.1602C10.9336 10.5117 10.4062 10.5117 10.0898 10.1602L7.3125 7.38281L5.09766 9.59766C4.74609 9.94922 4.21875 9.94922 3.90234 9.59766C3.55078 9.28125 3.55078 8.75391 3.90234 8.4375L6.71484 5.625C7.03125 5.27344 7.55859 5.27344 7.91016 5.625L10.6875 8.40234L13.9922 5.0625H12.0938C11.6016 5.0625 11.25 4.71094 11.25 4.21875Z",
		fill: "#38539A"
	})]
});
const ForwardRef = forwardRef(SvgIconMetricsGraph);
export { ForwardRef as ReactComponent };
